var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddUsers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.5,
    height: 17,
    viewBox: "0 0 23.5 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-person-add",
    "data-name": "Icon ionic-md-person-add",
    transform: "translate(-1.125 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_85",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 85",
    d: "M15.875,12.5a4,4,0,1,0-4-4A4.012,4.012,0,0,0,15.875,12.5Zm0,2c-2.65,0-8,1.35-8,4v2h16v-2C23.875,15.85,18.525,14.5,15.875,14.5Z",
    transform: "translate(0.25)",
    fill: "none",
    stroke: "#43b02a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_86",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 86",
    d: "M5.125,13.917V11.25H3.792v2.667H1.125V15.25H3.792v2.667H5.125V15.25H7.792V13.917Z",
    transform: "translate(0 -2.75)",
    fill: "#43b02a"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-users.3ca61a65.svg";
export { ForwardRef as ReactComponent };